<template>
<div class="IPHeader">
    <div style="width: 60px; height: 60px"></div>
    <div class="fileName">{{ fileName }}</div>
    <div class="IPClose" id="IPCloseId" @click="$emit('close')">
      <BwStop></BwStop>
    </div>
  </div>
</template>

<script>
import BwStop from "../icons/bw-stop.vue";

export default {
  components: {
    BwStop,
  },
  props: {
    fileName: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
.IPHeader {
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  height: 60px;
  box-sizing: border-box;

  .fileName {
    height: 25px;
    margin: 5px 16px 0;
    padding: 0 8px;
    overflow: hidden;
    font-size: 12px;
    line-height: 25px;
    color: #fff;
    text-overflow: ellipsis;
    white-space: nowrap;
    background-color: rgba(0, 0, 0, 0.7);
    border-radius: 4px;
  }

  .IPClose {
    z-index: 9;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    width: 40px;
    height: 40px;
    padding: 10px;
    margin-top: 40px;
    margin-right: 30px;
    user-select: none;
    background-color: rgba(0, 0, 0, 0.7);
    border-radius: 20px;
    cursor: pointer;

    &:hover {
      background-color: rgba(95, 95, 95, 0.7);
    }

    svg {
      width: 20px;
      height: 20px;
      color: #fff;
      fill: currentColor;
    }
  }
}
</style>
